export default __webpack_public_path__ + "static/media/XTZ.d3d4bdf5.svg";